// extracted by css-extract-rspack-plugin
var _1 = "occurrences-xt47JW";
var _2 = "statistics-AbnouP";
export { _1 as "occurrences", _2 as "statistics" }
